module.exports = __webpack_public_path__ + "static/media/tumble12.6f45f32d.jpg";